import * as React from 'react';

const LogoGoogleSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" {...props}>
        <g clipPath="url(#logo-google_svg__clip0)">
            <path
                d="M21.99 12.108c0-.84-.069-1.452-.216-2.088H12.2v3.79h5.62c-.113.943-.725 2.362-2.084 3.315l-.02.127 3.028 2.349.21.021c1.926-1.782 3.037-4.404 3.037-7.514"
                fill="#4285F4"
            />
            <path
                d="M12.2 22.096c2.753 0 5.064-.908 6.753-2.474l-3.218-2.497c-.862.602-2.017 1.021-3.536 1.021-2.697 0-4.985-1.781-5.801-4.244l-.12.01-3.148 2.44-.041.115c1.677 3.337 5.122 5.63 9.11 5.63z"
                fill="#34A853"
            />
            <path
                d="M6.397 13.902a6.298 6.298 0 01-.34-2.02c0-.704.125-1.385.33-2.02l-.007-.136-3.187-2.48-.104.05A10.238 10.238 0 002 11.881c0 1.646.397 3.201 1.088 4.586l3.308-2.565"
                fill="#FBBC05"
            />
            <path
                d="M12.2 5.616c1.914 0 3.206.829 3.942 1.521l2.879-2.814c-1.768-1.646-4.068-2.656-6.822-2.656-3.988 0-7.433 2.292-9.11 5.63L6.386 9.86c.828-2.463 3.116-4.245 5.813-4.245"
                fill="#EB4335"
            />
        </g>
        <defs>
            <clipPath id="logo-google_svg__clip0">
                <path
                    fill="#fff"
                    transform="translate(2 1.667)"
                    d="M0 0h20v20.5H0z"
                />
            </clipPath>
        </defs>
    </svg>
);

LogoGoogleSvg.displayName = 'LogoGoogleSvg';
export default LogoGoogleSvg;
